import {browserHistory} from 'react-router';
import axios from 'axios';

const baseEndpoint = 'v1/users';

const UserService = {

  deleteUser( id ) {
    return axios
      .delete( `${baseEndpoint}/${id}` )
  },

  recoverPassword( data ) {
    return axios
      .post( 'v1/user/recover-password', data )
  },

  changePassword( token, data ) {
    return axios
      .post( `v1/user/recover-password/${token}`, data )
  },

  adminChangePassword( user, data )
  {
    return axios
      .put( `v1/users/${user}/change/password`, data)

  },

  getCurrentUser( accessToken ) {
    if( accessToken ) return axios.get( 'v1/user-me', {
      headers: { Authorization: `Bearer ${accessToken}` }
    }, );
    return axios
      .get( 'v1/user-me'  )
  },

  getUsers( params, accessToken ) {
    if( accessToken ) return axios.get( baseEndpoint, {
      params,
      headers: { Authorization: `Bearer ${accessToken}` }
    }, );
    return axios
      .get( baseEndpoint, { params } )
  },

  getUser( id ) {
    return axios
      .get( `${baseEndpoint}/${id}` )
  },

  getUserSettings( id ) {
    return axios
      .get( `${baseEndpoint}/${id}/settings` )
  },

  saveUser( data ) {
    return axios
      .post( baseEndpoint, data )
  },

  updateUser( id, data ) {
    return axios
      .put( `${baseEndpoint}/${id}`, data )
  },

  updateUserSettings( id, data ) {
    return axios
      .put( `${baseEndpoint}/${id}/settings`, data )
  },

  updateUserEmailSettings( id, data ) {
    return axios
      .put( `${baseEndpoint}/${id}/email-settings`, data )
  },

  updateUserPassword( data ) {
    return axios
      .put( `v1/user/change/password`, data )
  },

  sendMessage( data ) {
    return axios
      .post( `v1/chat/message`, data )
  }

};

export default UserService;



// WEBPACK FOOTER //
// ./services/UserService.js